module.exports = __webpack_public_path__ + "img/ico-filter.036d39e5.svg";